function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import Text from '../Text/Text';
import Spinner from '../Spinner/Spinner';
import Tooltip from '../Tooltip/Tooltip';
import { elo as theme } from '../../themes';
import { StyledButton, StyledButtonContainer, StyledButtonContent, StyledSpinner } from './styles';
import IconBehavior from '../Icon/IconBehavior';
import iconList from '../Icon/iconList';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseButton = function BaseButton(_ref) {
  var badge = _ref.badge,
    children = _ref.children,
    highlight = _ref.highlight,
    icon = _ref.icon,
    iconDirection = _ref.iconDirection,
    inverted = _ref.inverted,
    loading = _ref.loading,
    size = _ref.size,
    disabled = _ref.disabled;
  return ___EmotionJSX(StyledButtonContainer, null, loading && ___EmotionJSX(StyledSpinner, null, ___EmotionJSX(Spinner, {
    inverted: inverted || highlight
  })), ___EmotionJSX(StyledButtonContent, {
    icon: icon,
    iconDirection: iconDirection,
    loading: loading
  }, children && ___EmotionJSX(Text, {
    size: size === 'small' ? 't3' : 't2',
    bold: true
  }, children), icon && ___EmotionJSX(IconBehavior, {
    initialIconProps: {
      type: icon,
      badge: badge
    },
    secondIconProps: {
      type: icon,
      badge: badge
    },
    container: StyledButton,
    disabled: disabled
  })));
};
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var isMobile = useMediaQuery({
    query: theme.breakpoints.mobile
  });
  return ___EmotionJSX(StyledButton, _extends({}, props, {
    ref: ref,
    "data-test-id": props.dataTestId,
    onlyIcon: props.icon && !props.children,
    loading: props.loading ? 'true' : null
  }), props.tooltipTitle && isMobile && props.disabled || props.tooltipTitle && !isMobile ? ___EmotionJSX(Tooltip, {
    title: props.tooltipTitle,
    position: props.tooltipPosition
  }, ___EmotionJSX(BaseButton, props)) : ___EmotionJSX(BaseButton, props));
});
Button.displayName = 'Button';
Button.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOf(Object.keys(iconList)),
  iconDirection: PropTypes.oneOf(['right', 'left']),
  inverted: PropTypes.bool,
  minimal: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  secondary: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  tooltipTitle: PropTypes.string,
  tooltipPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  loading: PropTypes.bool
};
BaseButton.propTypes = Button.propTypes;
Button.defaultProps = {
  disabled: false,
  iconDirection: 'right',
  onClick: function onClick() {
    return null;
  },
  size: 'medium',
  type: 'button'
};
export default Button;